import React from "react";

/**
 * حقل الترجمة (يملؤه الأدمن / المدرس) — اختياري.
 *
 * أمثلة الاستخدام:
 *   <TranslationField
 *     label="ترجمة نص السؤال"
 *     value={form.translation}
 *     onChange={(v) => setForm((f) => ({ ...f, translation: v }))}
 *   />
 *
 *   // في الفورمات اللي فيها أكتر من سؤال:
 *   <TranslationField
 *     value={q.translation}
 *     onChange={(v) => updateQuestion(idx, "translation", v)}
 *   />
 */
export default function TranslationField({
  label = "الترجمة",
  value,
  onChange,
  rows = 3,
  placeholder = "اكتب الترجمة هنا (اختياري)",
  className = ""
  , disabled = false,
}) {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <textarea
        dir="auto"
        rows={rows}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
      />
    </div>
  );
}